<template>
  <v-combobox
    v-bind="$attrs"
    outlined
    dense
    flat
    :menu-props="{ bottom: true, offsetY: true }"
    :class="{ focused: isFocused, 'error-input': hasError }"
    @focusin="isFocused = true"
    @focusout="isFocused = false"
    v-on="$listeners"
  >
    <template v-if="needSelection" #selection="{ attrs, item, selected }">
      <slot name="selection" :item="item" :attrs="attrs" :selected="selected" />
    </template>
    <template v-if="needItem" #item="{ item }">
      <slot name="item" :item="item" />
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "BaseComboBox",
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
    needSelection: {
      type: Boolean,
    },
    needItem: {
      type: Boolean,
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.focused {
  ::v-deep .v-input__slot {
    color: #2536cc !important;
    box-shadow: 0px 0px 12px 4px #ebf2ff !important;
  }
}
.error-input {
  ::v-deep .v-input__slot {
    color: #ff5267 !important;
    box-shadow: 0px 0px 8px 2px #ffc6c6 !important;
  }
}
::v-deep .v-list-item--link {
  margin: 8px;
  &:hover {
    background: rgba(155, 189, 255, 0.2);
    border-radius: 5px;
    overflow: hidden;
  }
}
::v-deep .v-list-item--active {
  background: rgba(155, 189, 255, 0.2);
  border-radius: 5px;
  overflow: hidden;
}
</style>
